<template lang="pug">
  SearchConditions(:initSearchCond="initSearchCond" @onChangeSearchConditions="onChangeSearchConditions" ref="cond")
    template(v-slot:conditions="{ conditions }")
      v-layout(wrap)
        v-flex(md3)
          v-text-field(label="荷主" v-model="conditions.clientName" clearable)
        v-flex(md3)
          v-text-field(label="荷主枝番" v-model="conditions.clientBranchName" clearable)
        v-flex(md3)
          v-text-field(label="積地" v-model="conditions.loadingPlace" clearable)
        v-flex(md3)
          v-text-field(label="卸地" v-model="conditions.unloadingPlace" clearable)
      v-layout(wrap)
        v-flex(md2)
          DatePicker(pickerLabel="積込予定日(from)" :initDate="conditions.loadingDateFrom"
            :inputDate.sync="conditions.loadingDateFrom" :isClearable="true")
        v-flex(md2)
          DatePicker(pickerLabel="積込予定日(to)" :initDate="conditions.loadingDateTo"
            :inputDate.sync="conditions.loadingDateTo" :isClearable="true")
        v-flex(md2)
          DatePicker(pickerLabel="納品予定日(from)"  initDate="" :inputDate.sync="conditions.unloadingDateFrom" :isClearable="true")
        v-flex(md2)
          DatePicker(pickerLabel="納品予定日(to)"  initDate="" :inputDate.sync="conditions.unloadingDateTo" :isClearable="true")
      v-layout(wrap)
        v-flex(md2)
          v-text-field(label="仮受注NO" v-model="conditions.provisionalOrderNo")
        v-flex(md2)
          v-text-field(label="カードID" v-model="conditions.cardIds" clearable maxlength="200")
        v-flex(md2)
          VehicleTypeMultiSelect(label="車格" :code.sync="conditions.vehicleTypeIdList" :clearable="true" clearable)
        v-flex(md2)
          DistanceTypeSelect(:code.sync="conditions.distanceType" :errorHandlerMethod="getErrorMessages" clearable)
        v-flex(md2)
          // 荷役区分
          HandlingUnitTypeSelect(:code.sync="conditions.handlingUnitType" :errorHandlerMethod="getErrorMessages" clearable)
        v-flex(md2)
          CardMarkSelect(:code.sync="conditions.markType" :errorHandlerMethod="getErrorMessages" multiple)
        v-flex(md2)
          ProvisionalOrderStatusTypeSelect(:code.sync="conditions.provisionalOrderStatus")

        v-flex(md5)
          v-text-field(label="備考" v-model="conditions.remark")
        v-flex(md5)
          v-text-field(label="配車メモ" v-model="conditions.dispatchMemo")
      v-layout(wrap)
        v-flex(md2)
          CheckOnOffSelect(:code.sync="conditions.arrangeFlg" labelDisp="手配済みフラグ" clearable)
        v-flex(md2)
          CreatorFilterSelect(:code.sync="conditions.creatorFilter" :errorHandlerMethod="getErrorMessages" clearable)
        v-flex(md2)
          ApplicantFilterSelect(:code.sync="conditions.applicantFilter" :errorHandlerMethod="getErrorMessages" clearable)


</template>

<script>
import SearchConditions from "@/components/common/search/SearchConditions";
import DatePicker from "@/components/common/DatePicker";
import DistanceTypeSelect from "@/components/common/select/DistanceTypeSelect";
import DispatchStatusSelect from "@/components/common/select/DispatchStatusSelect";
import { LabelName } from "@/assets/js/constants";
import VehicleTypeSelect from "@/components/common/select/VehicleTypeSelect.vue";
import VehicleTypeMultiSelect from "@/components/common/select/VehicleTypeMultiSelect.vue";
import ProvisionalOrderStatusTypeSelect from "@/components/common/select/ProvisionalOrderStatusTypeSelect.vue";
import OrderLossStatusSelect from "@/components/common/select/OrderLossStatusSelect.vue";
import HandlingUnitTypeSelect from "@/components/common/select/HandlingUnitTypeSelect.vue";
import CardMarkSelect from "@/components/common/select/CardMarkSelect.vue";
import ContractExistsSelect from "@/components/common/select/ContractExistsSelect.vue";
import CheckOnOffSelect from "@/components/common/select/CheckOnOffSelect.vue";
import CreatorFilterSelect from "@/components/common/select/CreatorFilterSelect.vue";
import ApplicantFilterSelect from "@/components/common/select/ApplicantFilterSelect.vue";

export default {
  components: {
    CheckOnOffSelect,
    ContractExistsSelect,
    HandlingUnitTypeSelect,
    ProvisionalOrderStatusTypeSelect,
    OrderLossStatusSelect,
    VehicleTypeMultiSelect,
    VehicleTypeSelect,
    SearchConditions,
    DatePicker,
    DistanceTypeSelect,
    DispatchStatusSelect,
    CardMarkSelect,
    CreatorFilterSelect,
    ApplicantFilterSelect
  },
  data: () => ({
    labelName: LabelName
  }),
  methods: {
    triggerSearch() {
      this.$refs.cond.submit();
    },
    onChangeSearchConditions(item) {
      this.$emit("onChangeSearchConditions", item);
    },
    getErrorMessages(field) {
      console.log(field);
      // if (errors.value[field]) return errors.value[field] ? errors.value[field][0] : "";
    },
    initSearchCond() {
      return {
        conditions: {
          clientName: "",
          clientBranchName: "",
          loadingDateFrom: "",
          loadingDateTo: "",
          loadingPlace: "",
          unloadingDateFrom: "",
          unloadingDateTo: "",
          unloadingPlace: "",
          orderDate: "",
          billingTypeName: "",
          planBoardNo: "",
          routeNo: "",
          slipNo: "",
          shipmentNo: "",
          cardIds: "",
          handlingUnitType: null,
          distanceType: null,
          markType: [],
          dispatchStatusList: [],
          remark: null,
          dispatchMemo: null,
          creatorFilter: null,
          applicantFilter: null
        }
      };
    }
  }
};
</script>
